import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbIncomingProcess", {params: params});
  },

  nextVbIncomingProcesses(processId, docId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({docId: docId}, pageable);
    return httpService.get(`vbIncomingProcess/${processId}/nextVbIncomingProcesses`, {params: params});
  },

  firstVbIncomingProcesses(docId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({docId: docId}, pageable);
    return httpService.get(`vbIncomingProcess/firstVbIncomingProcesses`, {params: params});
  },

  findById(id) {
    return httpService.get("vbIncomingProcess/" + id);
  },

  chuyenXuLi(form, id) {
    return httpService.post("vbIncomingProcess/chuyenXuLi/" + id, form);
  },

  chuyenXuLiVanThuBoSung(form, id) {
    return httpService.post("vbIncomingProcess/cxlVanThuBoSung/" + id, form);
  },

  chuyenXuLiDonVi(form, id) {
    return httpService.post("vbIncomingProcess/chuyenXuLiDonVi/" + id, form);
  },

  ketThuc(form, id) {
    return httpService.post("vbIncomingProcess/ketThuc/" + id, form);
  },

  tuChoi(form, id) {
    return httpService.put(`vbIncomingProcess/${id}/tuChoi`, form);
  },

  thuHoi(form, id) {
    return httpService.put(`vbIncomingProcess/${id}/thuHoi`, form);
  },

  findAllAccessible(vbIncomingProcessId) {
    return httpService.get("vbIncomingProcess/findAllAccessible", {params: {vbIncomingProcessId: vbIncomingProcessId}});
  },

  markAsRead(id) {
    return httpService.post("vbIncomingProcess/markAsRead/" + id, null);
  },

  getHistoryProcesses(docId, subDocId) {
    let params = {docId: docId, subDocId: subDocId};
    return httpService.get("vbIncomingProcess/getHistoryProcesses", {params: params});
  },

  choYKien(form, id) {
    return httpService.post("vbIncomingProcess/choYKien/" + id, form);
  },
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingProcessService.js